import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-logo-connect',
})
export class SignetLogoConnect {
  /**
   * Destination of the Logo
   */
  @Prop() href =  "http://connect.episource.com";
  
  /**
   * SRC of the logo (Optional)
   */
  @Prop() src =  'https://design.episource.com/img/logo/Product=Epiconnect.svg';

  /**
   * Alternative Text
   */
    @Prop() alt =  'Epi Connect Logo';

  private getLogoLink(): string {
    return ( this.href );
  }

  private getImageLink(): string {
    return ( this.src );
  }


  private getAltText(): string {
    return ( this.alt );
  }

  render() {
    return (
      <a class='signet-logo-connect signet-product-icon' href={this.getLogoLink()}><img src={this.getImageLink()} alt={this.getAltText()} /></a>
    );
  }
}
